import { GET_USER, LOAD_START, LOAD_END, CLEAR_USER } from "./types";
import SuperAdminServices from "../../services/superAdmin.services";
import { openNotification } from "../Notification/notifications.action";

export const getSingleUser = (userId) => (dispatch) => {
  dispatch({ type: LOAD_START });
  return SuperAdminServices.getSingleUser(userId)
    .then(({ data: { data } }) => {
      dispatch({ type: GET_USER, payload: data?.admin[0] });
      dispatch({ type: LOAD_END });
    })
    .catch((err) => {
      const error = err?.response?.message || err?.response?.statusText;
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
    });
};

export const changePassword = (data) => (dispatch) => {
  return SuperAdminServices.changePassword(data)
    .then(({ data }) => {
      console.log(data);
    })
    .catch((err) => {
      const error =
        err?.response?.message ||
        err?.response?.statusText ||
        "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
    });
};

export const clearUser = () => (dispatch) => {
  dispatch({
    type: CLEAR_USER,
  });
};
